// An authorised media url carries its credential as `?authorization=JWT%20<token>`, because an <img>
// cannot send a header. Anything that fetches one (the recording player does) puts that url into
// error messages, fetch breadcrumbs and tracing spans, so every string bound for Sentry is
// scrubbed rather than each place that might hold one.
const MEDIA_CREDENTIAL = /([?&]authorization=)(?:JWT(?:%20|\+|\s))?[^&#\s"'`):]*/gi;

// Holds live Scope instances, so walking it would reach the whole client. All that is sent from it
// is the sampling context, which carries no urls.
const UNSENT_KEYS = ['sdkProcessingMetadata'];

const redactMediaCredential = (text: string): string => text.replace(MEDIA_CREDENTIAL, '$1[redacted]');

const redactWithin = (value: unknown, seen: WeakSet<object>): void => {
    if (!value || typeof value !== 'object' || seen.has(value)) {
        return;
    }
    seen.add(value);

    for (const [key, item] of Object.entries(value)) {
        if (UNSENT_KEYS.includes(key)) {
            continue;
        }
        if (typeof item === 'string') {
            const redacted = redactMediaCredential(item);
            // Written only when something was redacted, so a string without a credential is never
            // touched, and neither is the object holding it.
            if (redacted !== item) {
                Reflect.set(value, key, redacted);
            }
        } else {
            redactWithin(item, seen);
        }
    }
};

// Rewrites, in place, every string inside a Sentry event that carries a media credential.
export const redactMediaCredentials = (value: unknown): void => redactWithin(value, new WeakSet());
